import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { HiPlus } from "react-icons/hi";
import { FaPlus, FaMinus } from "react-icons/fa";
import FAQuestion from "../Assessts/Images/Home/FAQ-Question.png";
const FAQS = () => {
    const [FAQLogin, SetFAQLogin] = useState(false);
    const [FAQRenewal, SetFAQRenewal] = useState(false);
    const [FAQDeclaration, SetFAQDeclaration] = useState(false);
    const [FAQCourses, SetFAQCourses] = useState(false);
    return (
        <>
            <div className="FAQ-Maindiv p-2">
                <div className="Web-MainHeading mb-3" >Top FAQs</div>
                <div className="container-fluid FAQ-Heading mb-4">
                    <Row>
                        <Col>
                            <div className="Card">
                                <div className=" dflex JSBetween alignitems"> <span className="dflex gap-3 alignitems "><HiPlus /> <b style={{ alignItems: "flex-start" }}>How do I apply for the NSF Fresh Scholarship?</b></span> <span className="CPointer" onClick={() => SetFAQLogin(!FAQLogin)}>{FAQLogin ? <FaMinus /> : <FaPlus />}</span> </div>
                                {FAQLogin &&
                                <> 
                                <span className="m-3">Follow these steps :</span>
                                <ul  style={{marginLeft:'15px'}}>
                                    <li>Visit the NSF Scholarship Portal</li>
                                    <li>Click on “Apply for Scholarship”</li>
                                    <li>Check eligibility - If, Eligible (As per NSF norms)</li>
                                    <li>Select Fresh Application</li>
                                    <li>Register using your Email ID / Mobile Number</li>
                                    <li>Fill in personal, academic, and financial details</li>
                                    <li>Upload required documents</li>
                                    <li>Review and submit the application</li>
                                    <li>Take a printout (if required) and submit hard copies to your respective chapter.</li>
                                </ul></>}
                            </div>
                        </Col>
                        <Col>
                            <div className="Card">
                                <div className=" dflex JSBetween alignitems"> <span className="dflex gap-3 alignitems"><HiPlus /> <b>What is declaration of the principal?</b></span>  <span className="CPointer" onClick={() => SetFAQDeclaration(!FAQDeclaration)}>{FAQDeclaration ? <FaMinus /> : <FaPlus />}</span></div>
                                {FAQDeclaration && <ul className="mt-2">After the form submission online, you will get one PDF form and check the last page for the Declaration by the principal. It should be filled by the principal of your college.
                                    <img src={FAQuestion} alt="FAQ-Question" className="p-1" /></ul>}
                            </div>

                        </Col>
                    </Row>

                    <Row className="mt-3">
                        <Col>
                            <div className="Card">
                                <div className=" dflex JSBetween alignitems"><span className="dflex gap-3 alignitems"> <HiPlus /> <b>How do I apply for a Renewal Scholarship?</b></span>   <span className="CPointer" onClick={() => SetFAQRenewal(!FAQRenewal)}>{FAQRenewal ? <FaMinus /> : <FaPlus />}</span> </div>
                                {FAQRenewal &&
                                <> 
                                <span className="m-3">Follow these simple steps :</span>
                                <ul style={{marginLeft:'15px'}}>
                                    <li>Visit the NSF Scholarship Portal</li>
                                    <li>Click on “Login”</li>
                                    <li>Enter your registered credentials</li>
                                    <li>Select Renewal Application</li>
                                    <li>Update academic progress and current course details</li>
                                    <li>Upload required renewal documents</li>
                                    <li>Review and submit the application</li></ul></>}
                            </div>
                        </Col>
                        <Col>
                            <div className="Card">
                                <div className=" dflex JSBetween alignitems"> <span className="dflex gap-3 alignitems"><HiPlus /> <b>What courses are eligible for scholarships ?</b></span> <span className="CPointer" onClick={() => SetFAQCourses(!FAQCourses)}>{FAQCourses ? <FaMinus /> : <FaPlus />}</span></div>
                                {FAQCourses && <ul>
                                    <li>Degree in Agriculture B.Sc.</li>
                                    <li>Degree in Dentistry (B.D.S.)</li>
                                    <li>Degree in Engineering (B.E./ B.Tech, 4-Year Degree in Engineering)</li>
                                    <li>Lateral Entry to Degree in Engineering (B.E./B.Tech)</li>
                                    <li>Degree in Medicine (M.B.B.S.)</li>
                                    <li>Degree in Nursing B.Sc (N)</li>
                                    <li>Degree in B.Pharma</li>
                                    <li>BA BEd & B.Sc BEd (Limited to Regional Institutes of Education of NCERT Ajmer, Bhopal, Bhubaneswar, Mysore, Shillong)</li>
                                    <li>Diploma in Engineering (Polytechnic/ 3-Year Diploma)</li>
                                    <li>Diploma in Agriculture</li>
                                </ul>}
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}
export default FAQS;